var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMk = function SvgMk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M13.826 23.862a11.935 11.935 0 0 0 5.271-2.185L12.001 12l1.825 11.862ZM10.176.138a11.937 11.937 0 0 0-5.272 2.185L12.001 12 10.176.138ZM4.904 21.677a11.938 11.938 0 0 0 5.272 2.186L12 12l-7.097 9.677ZM2.324 4.902a11.937 11.937 0 0 0-2.185 5.272L12 11.999 2.324 4.902ZM.139 13.825a11.936 11.936 0 0 0 2.185 5.272L12 12 .139 13.825Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M23.863 10.174a11.937 11.937 0 0 0-2.185-5.271L12 11.999l11.862-1.825Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M19.097 2.323A11.936 11.936 0 0 0 13.826.138L12 12l7.096-9.677ZM21.678 19.097a11.937 11.937 0 0 0 2.185-5.272L12.001 12l9.677 7.097Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12.001 16.174a4.174 4.174 0 1 0 0-8.347 4.174 4.174 0 0 0 0 8.347Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 15.13a3.13 3.13 0 1 0 0-6.261 3.13 3.13 0 0 0 0 6.26Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMk;